import { Component, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { SvgIconService } from 'app/shared/services/svgIcons.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { SeoService } from '@shared/services/seo.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { ProgramLauncherComponent } from './player-view/program-launcher/program-launcher.component';

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {
  showTopBar = true;
  private _queryParamSub: Subscription;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _fuseSplashScreenService: FuseSplashScreenService, // import mandatory otherwise splash screen never disappear
    private _platform: Platform,
    private iconService: SvgIconService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService,
    private _dialog: MatDialog,
    private _coursesApiService: CoursesAPIService
  ) {
    // Add is-mobile class to the body if the platform is mobile
    if (this._platform.ANDROID || this._platform.IOS) {
      this.document.body.classList.add('is-mobile');
    }
    this.iconService.registerIcons();

    // Read route custom data parameters to show topbar or not (may be useful for other embeds of editor page into player)
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        this.showTopBar = !data['hideTopBar'];
        if (data['noIndex']) {
          this.seoService.setNoindex();
        } else {
          this.seoService.setIndex();
        }
      });

    this._queryParamSub = this.activatedRoute.queryParams
      .pipe(
        map(params => params['pl']),
        distinctUntilChanged(),
        filter(programId => !!programId),
        switchMap(programId => this._coursesApiService.getLearnspaceById(programId))
      )
      .subscribe(learnspace => {
        this._dialog.open(ProgramLauncherComponent, {
          data: { learnspace },
          panelClass: 'program-launcher-dialog',
          // MatDialog defaults maxWidth to 80vw — updateSize() in the
          // component (which sizes to the viewport minus a small margin,
          // more so on mobile) can never exceed that cap otherwise.
          maxWidth: '100vw',
          maxHeight: '100vh'
        });
      });
  }

  ngOnDestroy() {
    this._queryParamSub.unsubscribe();
  }
}
